import api from './api'
import {
  AprovarCadastroRequest,
  AvaliarCandidaturaRequest,
  CandidaturaCadastro,
  CadastroConsultorRequest,
  Candidatura,
  CandidaturaRequest,
  ConviteEmitido,
  ConvitePrefill,
  StatusCandidatura,
} from '@/types/candidatura'
import { PageResponse } from '@/types/comum'

const BASE_URL = '/api/v1/candidaturas'

export const candidaturaService = {
  /**
   * Envio público — não exige login. O backend responde 202 mesmo quando o e-mail já
   * está na fila, então "enviado" aqui não significa "candidatura nova".
   */
  enviar: async (request: CandidaturaRequest): Promise<void> => {
    await api.post(BASE_URL, request)
  },

  listar: async (
    status?: StatusCandidatura,
    page = 0,
    size = 20
  ): Promise<PageResponse<Candidatura>> => {
    const filtro = status ? `&status=${status}` : ''
    const response = await api.get<PageResponse<Candidatura>>(
      `${BASE_URL}?page=${page}&size=${size}${filtro}`
    )
    return response as unknown as PageResponse<Candidatura>
  },

  avaliar: async (id: string, request: AvaliarCandidaturaRequest): Promise<Candidatura> => {
    const response = await api.put<Candidatura>(`${BASE_URL}/${id}/avaliacao`, request)
    return response as unknown as Candidatura
  },

  /** Cadastro submetido, para a validação da Etapa 3. */
  obterCadastro: async (id: string): Promise<CandidaturaCadastro> => {
    const response = await api.get<CandidaturaCadastro>(`${BASE_URL}/${id}/cadastro`)
    return response as unknown as CandidaturaCadastro
  },

  /** Aprova o cadastro e configura o perfil de acesso (tenant e canal). */
  aprovarCadastro: async (
    id: string,
    request: AprovarCadastroRequest
  ): Promise<CandidaturaCadastro> => {
    const response = await api.post<CandidaturaCadastro>(`${BASE_URL}/${id}/aprovacao`, request)
    return response as unknown as CandidaturaCadastro
  },

  /** Emite o convite. O token vem UMA ÚNICA VEZ — não há endpoint que o recupere. */
  emitirConvite: async (id: string): Promise<ConviteEmitido> => {
    const response = await api.post<ConviteEmitido>(`${BASE_URL}/${id}/convite`, {})
    return response as unknown as ConviteEmitido
  },
}

const CONVITES_URL = '/api/v1/convites'

/** Cadastro por convite — público: quem preenche ainda não tem conta. */
export const conviteService = {
  abrir: async (token: string): Promise<ConvitePrefill> => {
    const response = await api.get<ConvitePrefill>(`${CONVITES_URL}/${token}`)
    return response as unknown as ConvitePrefill
  },

  cadastrar: async (token: string, request: CadastroConsultorRequest): Promise<void> => {
    await api.post(`${CONVITES_URL}/${token}/cadastro`, request)
  },
}
